import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Collapse, CardBody, Card } from 'reactstrap';
import { FaAngleUp, FaAngleRight, FaPhone, FaMoneyBillWave } from 'react-icons/fa';
import { Row, DropdownDiv, AccordionTitle, ButtonDiv, DropdownStyle } from '../Assets/Constants/styles';
import {
  travelNetURL,
  policyDocumentsText,
  policyChangesText,
  userSupportText,
  customerSupportEmail,
  billingEmail,
  claimsText,
  accordionTitle1,
  accordionTitle2,
  accordionTitle3,
  travelNetText,
  noLogin,
  payBill,
  contactUs,
  frequentQ,
} from '../Assets/Constants/constants';

class LoginScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      firstAccordionExpand: false,
      secondAccordionExpand: false,
      thirdAccordionExpand: false,
      isMobile: window.innerWidth <= 920,
    };
    this.toggleFirstAccordion = this.toggleFirstAccordion.bind(this);
    this.toggleSecondAccordion = this.toggleSecondAccordion.bind(this);
    this.toggleThirdAccordion = this.toggleThirdAccordion.bind(this);
  }

  handleModal() {
    this.setState({ modalOpen: !this.state.modalOpen });
  }

  toggleFirstAccordion() {
    this.setState({ firstAccordionExpand: !this.state.firstAccordionExpand });
  }

  toggleSecondAccordion() {
    this.setState({ secondAccordionExpand: !this.state.secondAccordionExpand });
  }

  toggleThirdAccordion() {
    this.setState({ thirdAccordionExpand: !this.state.thirdAccordionExpand });
  }
  onHover(param) {
    const button = document.getElementById(param);
    button.style.backgroundColor = 'rgba(18, 120, 221, 0.13)';
  }
  onLeave(param) {
    const button = document.getElementById(param);
    button.style.backgroundColor = 'white';
    button.style.outline = 'none';
  }

  render() {
    const { isMobile } = this.state;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}
      >
        <div
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <div
            style={{
              marginTop: 10,
              marginRight: 60,
              marginLeft: 0,
              borderLeft: '1px solid #c0c0c0',
              height: '458px',
              borderRadius: 5,
              display: isMobile ? 'none' : 'block',
            }}
          />
        </div>

        <div
          style={{
            flexDirection: 'column',
            maxWidth: '334px',
          }}
        >
          <h1 style={headerStyle}>{noLogin}</h1>
          <div style={{ flexDirection: 'row', marginTop: 20 }}>
            <Button
              id="payBill"
              onMouseOver={() => this.onHover('payBill')}
              onMouseOut={() => this.onLeave('payBill')}
              onFocus={() => {
                this.onLeave('payBill');
              }}
              style={buttonStyle}
              onClick={() => {
                window.open('/pay-bill', '_blank');
              }}
            >
              <ButtonDiv>
                <FaMoneyBillWave role="img" aria-label="faPhone" style={buttonIconStyle} />
                {payBill}
              </ButtonDiv>
            </Button>
            <span style={{ marginLeft: 30 }} />
            <Button
              style={buttonStyle}
              id="contactUs"
              onMouseOver={() => this.onHover('contactUs')}
              onMouseOut={() => this.onLeave('contactUs')}
              onFocus={() => {
                this.onLeave('contactUs');
              }}
              onClick={() => this.handleModal()}
            >
              <ButtonDiv>
                <FaPhone role="img" aria-label="faPhone" style={buttonIconStyle} />
                {contactUs}
              </ButtonDiv>
            </Button>
          </div>
          <div style={{ marginTop: 40 }}>
            <h1 style={headerStyle}>{frequentQ}</h1>

            <div style={{ marginTop: 20 }}>
              <DropdownStyle>
                <div
                  onClick={this.toggleFirstAccordion}
                  onKeyDown={this.toggleFirstAccordion}
                  role="button"
                  tabIndex={-1}
                >
                  <DropdownDiv>
                    <AccordionTitle>{accordionTitle1}</AccordionTitle>
                    {this.state.firstAccordionExpand ? (
                      <FaAngleUp role="img" aria-label="faLeft" style={IconStyle} />
                    ) : (
                      <FaAngleRight role="img" aria-label="faDown" style={IconStyle} />
                    )}
                  </DropdownDiv>
                </div>
              </DropdownStyle>
              <Collapse isOpen={this.state.firstAccordionExpand}>
                <Card style={cardStyle}>
                  <CardBody>
                    <Row>
                      <div className="col-12">
                        {travelNetText}{' '}
                        <a style={{ color: '#0078d4', cursor: 'pointer' }} href={travelNetURL}>
                          TravelNet
                        </a>{' '}
                        is only available to policyholders in specific states.
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Collapse>
            </div>

            <div style={{ marginTop: 20 }}>
              <DropdownStyle>
                <div
                  onClick={this.toggleSecondAccordion}
                  onKeyDown={this.toggleSecondAccordion}
                  role="button"
                  tabIndex={-1}
                >
                  <DropdownDiv>
                    <AccordionTitle>{accordionTitle2}</AccordionTitle>
                    {this.state.secondAccordionExpand ? (
                      <FaAngleUp role="img" aria-label="faLeft" style={IconStyle} />
                    ) : (
                      <FaAngleRight role="img" aria-label="faDown" style={IconStyle} />
                    )}
                  </DropdownDiv>
                </div>
              </DropdownStyle>
              <Collapse isOpen={this.state.secondAccordionExpand}>
                <Card style={cardStyle}>
                  <CardBody>
                    <Row>
                      <div className="col-12">
                        <div>{policyDocumentsText}</div>
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Collapse>
            </div>

            <div style={{ marginTop: 20 }}>
              <DropdownStyle>
                <div
                  onClick={this.toggleThirdAccordion}
                  onKeyDown={this.toggleThirdAccordion}
                  role="button"
                  tabIndex={-1}
                >
                  <DropdownDiv>
                    <AccordionTitle>{accordionTitle3}</AccordionTitle>
                    {this.state.thirdAccordionExpand ? (
                      <FaAngleUp role="img" aria-label="faLeft" style={IconStyle} />
                    ) : (
                      <FaAngleRight role="img" aria-label="faDown" style={IconStyle} />
                    )}
                  </DropdownDiv>
                </div>
              </DropdownStyle>
              <Collapse isOpen={this.state.thirdAccordionExpand}>
                <Card style={cardStyle}>
                  <CardBody style={{ borderRadius: 0 }}>
                    <Row>
                      <div className="col-12">
                        <div>{policyChangesText}</div>
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Collapse>
            </div>
          </div>
        </div>

        <Modal
          className="paperless-modal"
          show={this.state.modalOpen}
          onHide={() => this.handleModal()}
          backdrop="static"
          scrollable={true}
        >
          <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
            <Modal.Title style={{ textAlign: 'left', fontWeight: '700', fontSize: 24, color: '#616161' }}>
              {'Contact Us'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body scrollable={true}>
            <div>
              <p style={{ fontWeight: 700, fontSize: 18, color: '#616161' }}>User Support</p>
              <div style={modalTextStyle}>
                {userSupportText}{' '}
                <a style={linkText} href={'mailto: ' + customerSupportEmail}>
                  {customerSupportEmail}
                </a>
                .
              </div>
              <p style={{ fontWeight: 700, marginTop: 25, fontSize: 18, color: '#616161' }}>Billing</p>
              <div style={modalTextStyle}>
                You can call us at 1-800-236-5002 Monday through Friday during our business hours of 7:00 AM to 4:30 PM
                CST, or email us anytime at{' '}
                <a style={linkText} href={'mailto: ' + billingEmail}>
                  {billingEmail}
                </a>
                . Please include your billing account number with your inquiry.
              </div>
              <p style={{ fontWeight: 700, marginTop: 25, fontSize: 18, color: '#616161' }}>Claims</p>
              <div style={modalTextStyle}>
                {claimsText}{' '}
                <a style={linkText} href="https://www.thesilverlining.com/claims">
                  Click here to learn more
                </a>
                .
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const IconStyle = {
  fontSize: 20,
  paddingLeft: 0,
  paddingRight: 5,
  color: '#d1d1d1',
  verticalAlign: 'middle',
  textAlign: 'right',
};
const buttonIconStyle = {
  fontSize: 30,
  color: '#0078d4',
  alignSelf: 'center',
  marginBottom: 5,
};
const buttonStyle = {
  border: '2px solid',
  fontWeight: 500,
  borderColor: '#0078d4',
  fontSize: 18,
  color: '#0078d4',
  padding: 0,
  position: 'relative',
  width: '40%',
  height: '85px',
};

const headerStyle = {
  fontSize: '24px',
  color: '#616161',
  textAlign: 'left',
  verticalAlign: 'middle',
};

const modalTextStyle = { fontSize: 16, lineHeight: 1.3 };
const cardStyle = {
  borderColor: '#797979',
  borderTop: 'none',
  borderRadius: '0 0 3px 3px',
  width: '100%',
};
const linkText = { color: '#0078d4', cursor: 'pointer', textDecoration: 'underline' };

export default LoginScreen;
